module.exports = __webpack_public_path__ + "static/media/Tijuana.b7dbaa7e.mov";